module.exports = __webpack_public_path__ + "static/img/01.80f309c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/altcoin/01.png
// module id = hlo2
// module chunks = 0